import { PieChart } from "../global/components/piecharts/PieChart";
import { DisplayMapView } from "../global/MapView";
import CardMedia from "@mui/material/CardMedia";
import Draggable from "react-draggable";
import * as React from "react";
import IconButton from "@mui/material/IconButton";
import { Icon } from "@vds/icons";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { LineChartUI } from "../global/components/linecharts/LineChart";
//import DocsListComponent from "../components/resources/Resources";
//import { HealthBoxWidget } from "../global/components/widgetGrids/WidgetGridDynamic";
//import { BatteryBoxWidget } from "../global/components/widgetGrids/BatteryBoxWidget";
import { MyResponsiveBar } from "../global/components/barCharts/Barchart";
import { MyResponsiveScatterPlot } from "../global/components/scatterPlot/ScatterPlot";
import {
  MyVideoPlayer,
  PlayHLSVideo,
  PlayMP4Video,
} from "../global/components/VideoPlayer";
import EbcFloorPlan from "../global/components/floorPlan/EbcFloorPlan";
import { getCameraObjectbyId } from "./reportService";

export const GetComponentTypes = (component, title, compInfo) => {
  //const defaultCameraList = useSelector(state => state.deviceReducer.cameraList);

  switch (component) {
    case ComponentTypes.pieChart:
      return <PieChart compInfo={compInfo} />;
    case ComponentTypes.lineChart:
      return (
        <LineChartUI
          finalKeys={compInfo[0]}
          sensorData={compInfo[1]}
          legend={compInfo[2]}
          ble={compInfo[3]}
        />
      );
    case ComponentTypes.barChart:
      return <MyResponsiveBar />;

    case ComponentTypes.scatter:
      return (
        <MyResponsiveScatterPlot
          finalKeys={compInfo[0]}
          sensorData={compInfo[1]}
          legend={compInfo[2]}
          ble={compInfo[3]}
        />
      );

    case ComponentTypes.cardView:
      return (
        <>
          {title === "Floor Plan" ? (
            <div
              style={{
                width: "100%",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <CardMedia
                component="img"
                image={compInfo.backgroundImage}
                alt="Background Image"
                style={{
                  height: "300px",
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  position: "relative",
                }}
              />
              <Draggable axis="both" allowAnyClick={true} bounds="parent">
                <div
                  style={{
                    position: "absolute",
                    top: "29%", //change these positions whenever you change position
                    left: "17%",
                  }}
                >
                  <img
                    src={compInfo.img}
                    alt="Camera Icon"
                    style={{
                      width: "13px",
                      height: "13px",
                      borderRadius: "50%",
                    }}
                  />
                </div>
              </Draggable>
            </div>
          ) : (
            <CardMedia
              component="img"
              image={compInfo.img1}
              alt="sensor image"
              style={{
                height: "300px",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                position: "relative",
              }}
            />
          )}
        </>
      );

    case ComponentTypes.floorPlan:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            // paddingTop: "30px",
            height: "386px",
          }}
        >
          <EbcFloorPlan
            cameras={getCameraObjectbyId(compInfo.cameraId)}
            //dashboard={true}
            floorImage={compInfo.floorPlanImage}
            showHazard={false}
            FloorSize={[640, 332]}
            widgetSize={false}            
            isEditable={false}
            imageLoading={compInfo.imageLoading}
            iscamInfo={true}
            cameraId={compInfo.cameraId}
            unresolvedEventData={compInfo.unresolvedEventData}
          />
        </div>
      );

    case ComponentTypes.mapView:
      return <DisplayMapView compInfo={compInfo} />;
    case ComponentTypes.videoView:
      return <PlayHLSVideo compInfo={compInfo} />;
    default:
      return component;
  }
};

export const ComponentTypes = {
  pieChart: "pieChart",
  mapView: "mapView",
  lineChart: "lineChart",
  barChart: "barChart",
  cardView: "cardView",
  healthBoxGrid: "healthBoxGrid",
  batteryBoxGrid: "batteryBoxGrid",
  scatter: "scatter",
  videoView: "videoView",
  floorPlan: "floorPlan",
};
